module.exports = __webpack_public_path__ + "media/images/weo-gris-c772f95160144515b52c5efbc15b48a9.svg";